"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Button2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Box = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _InputField = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputField"));
var _ModalHeader = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalHeader"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _ChevronBackward2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ChevronBackward"));
var _DateInput = _interopRequireDefault(require("../../../../DateInput"));
var _IataPicker = _interopRequireDefault(require("../../../../IataPicker"));
var _jsxRuntime = require("react/jsx-runtime");
var _ChevronBackward, _FormattedMessage, _Button;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GetSingleBooking = _ref => {
  let {
    bookingId,
    bookingIdError,
    email,
    emailError,
    departureDate,
    departureDateError,
    IATA,
    IATAError,
    error,
    onBookingIdChange,
    onEmailChange,
    onDepartureDateChange,
    onIATAChange,
    onBack,
    onSubmit
  } = _ref;
  const intl = (0, _reactIntl.useIntl)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalHeader.default, {
      title: intl.formatMessage({
        id: "account.sign_in.single_booking.title"
      }),
      description: intl.formatMessage({
        id: "account.sign_in.single_booking.description"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
      dataTest: "MagicLogin-GetSingleBooking",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
        onSubmit: onSubmit,
        name: "loginGetSingleBooking",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
          direction: "column",
          spacing: "XLarge",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
            direction: "column",
            children: [error != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
              type: "critical",
              icon: true,
              labelClose: intl.formatMessage({
                id: "orbit.button_close"
              }),
              children: error
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
              type: "number",
              inputMode: "decimal",
              label: intl.formatMessage({
                id: "account.sign_in.bid_number_label"
              }),
              placeholder: intl.formatMessage({
                id: "account.sign_in.bid_number_placeholder"
              }),
              value: bookingId,
              error: bookingIdError == null ? "" : intl.formatMessage(bookingIdError),
              onChange: onBookingIdChange,
              dataTest: "MagicLogin-BookingId"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
              inputMode: "email",
              autoComplete: "email",
              label: intl.formatMessage({
                id: "account.sign_in.incorrect_email_label"
              }),
              placeholder: intl.formatMessage({
                id: "account.sign_in.incorrect_email_placeholder"
              }),
              value: email,
              error: emailError == null ? "" : intl.formatMessage(emailError),
              onChange: onEmailChange,
              dataTest: "MagicLogin-Email"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateInput.default, {
              value: departureDate,
              error: departureDateError == null ? "" : intl.formatMessage(departureDateError),
              onChange: onDepartureDateChange,
              label: intl.formatMessage({
                id: "account.sign_in.departure_date_label"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
              width: "full",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IataPicker.default, {
                id: "MagicLogin-IATA",
                value: IATA,
                withIcon: false,
                onSelect: onIATAChange,
                error: IATAError && intl.formatMessage(IATAError)
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
            direction: "row",
            justify: "between",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button2.default, {
              type: "secondary",
              iconLeft: _ChevronBackward || (_ChevronBackward = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronBackward2.default, {})),
              onClick: onBack,
              dataTest: "MagicLogin-GetSingleBookingBack",
              children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "account.back"
              }))
            }), _Button || (_Button = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button2.default, {
              submit: true,
              dataTest: "MagicLogin-GetSingleBookingSubmit",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "submit"
              })
            }))]
          })]
        })
      })
    })]
  });
};
var _default = exports.default = GetSingleBooking;